/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getWebAuthnCredentialsInternal} from '../api'

 export const useQueryGetWebAuthnCredentialsInternal = createReactQueryHook('getWebAuthnCredentialsInternal', getWebAuthnCredentialsInternal)
